import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
interface IModalCommon {
    handleClose?: any;
    sharedArr: any[];
    owner: string;
    addShared: any;
}

const CustomSelect = styled(Select)({
  '.MuiSelect-icon': {
    color: '#BDBEC1'
  },
  'overflow': 'hidden',
  'color': 'var(--Text-Main, #EFF1F6)',
  'textOverflow': 'ellipsis',
  'fontFamily': 'Inter',
  'fontSize': '16px',
  'fontStyle': 'normal',
  'fontWeight': 400,
  'lineHeight': '24px',
  'borderRadius': '8px',
  'border': '1px solid #2E3036'
});

const AddPersonModal: React.FC<IModalCommon> = ({ handleClose, sharedArr, owner, addShared }) => {
  const [ shareEmail, setShareEmail ] = useState('');
  const { userOpts } = useContext(GlobalContext);
  const [ shareOptions, setShareOptions ] = useState<any[]>([]);

  const handleShare = async() => {
    if (shareEmail.length > 0) {
      addShared(shareEmail);
      handleClose();
    }
  };

  const handleShareChange = (e: any) => {
    setShareEmail(e.target.value);
  };

  const filterUserOpts = (str: string, arr: string[]) => {
    setShareOptions(userOpts.filter((opt: any) => ![ str, ...arr ].includes(opt.label)));
  };

  useEffect(() => {
    filterUserOpts(owner, sharedArr);
  }, []);


  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont'>
          <div className='audit-add-modal-head-cont-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='audit-add-modal-head-cont-supporting'>
            <h1>Share ticket</h1>
            <p>Share and manage who can see this ticket.</p>
          </div>
        </div>
        <div className='audit-add-modal-head-close' onClick={handleClose}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='audit-add-modal-cont-body'>
        <div className='audit-add-modal-cont-body-frame'>
          <div className='audit-add-modal-cont-body-frame-form'>
            <div className='audit-add-modal-cont-body-frame-form-row'>
              <div className='audit-add-modal-cont-body-frame-form-row-input'>
                <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                  <div className='audit-add-modal-cont-body-frame-form-row-input-label-text'>
                    Add User
                  </div>

                  <FormControl sx={{ width: '100%' }}>
                    <CustomSelect
                      value={shareEmail}
                      onChange={handleShareChange}
                      fullWidth
                      IconComponent={KeyboardArrowDownIcon}
                      inputProps={{
                        MenuProps: {
                          MenuListProps: {
                            sx: {
                              backgroundColor: '#202227',
                              color: 'var(--Text-Main, #EFF1F6)',
                            }
                          }
                        }
                      }}
                    >
                      <MenuItem value=''>
                        <em>Select One</em>
                      </MenuItem>
                      {shareOptions.map((user: any, i: number) => (
                        <MenuItem key={i} value={user.label}>{user.label}</MenuItem>
                      ))}
                    </CustomSelect>
                  </FormControl>


                  {/* <input className='audit-add-modal-cont-body-frame-form-input' type='text' placeholder='Enter email' value={shareEmail} onChange={(e) => {
                    handleShareChange(e);
                  }}/> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className='audit-add-modal-cont-body-frame-form'>
            <div className='audit-add-modal-cont-body-frame-form-row'>
              <div className='audit-add-modal-cont-body-frame-form-row-input'>
                <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                  <div className='audit-add-modal-cont-body-frame-form-row-input-label-text'>
                    Permissions
                  </div>
                  <select className='audit-add-modal-cont-body-frame-form-input'>
                    <option className='bulk-selection-option' >Select permissions</option>
                    <option className='bulk-selection-option' >Contributor</option>
                    <option className='bulk-selection-option' >Restricted</option>
                  </select>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div className='audit-add-modal-contents'>
        <h1>People With Access</h1>
        <div className='audit-add-modal-contents-frame'>
          <div className='audit-add-modal-contents-frame-cell'>
            <div className='audit-add-modal-contents-frame-cell-name'>{owner}</div>
            <div className='audit-add-modal-contents-frame-cell-perm'>Owner</div>
          </div>
          {sharedArr.map((member: string, i: number) => (
            <div key={i} className='audit-add-modal-contents-frame-cell'>
              <div className='audit-add-modal-contents-frame-cell-name'>{member}</div>
              <div className='audit-add-modal-contents-frame-cell-perm'>Contributor</div>
            </div>
          ))}
          {/* <div className='results-card-frame-footer'>
          Manage access
          </div> */}
        </div>
      </div>
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div className='audit-modal-cont-footer-content-btn-cancel' onClick={handleClose}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Cancel
            </div>
          </div>
          <div className='audit-modal-cont-footer-content-btn-upload' onClick={handleShare}>
            <div className='audit-modal-cont-footer-content-btn-text'>
                Share
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPersonModal;
